import { Injectable } from '@angular/core';
import * as forge from 'node-forge';

@Injectable({ providedIn: 'root' })
export class CertificateService {
  parsePem(certificate: string): forge.pki.Certificate | null {
    if (!certificate) {
      return null;
    }

    try {
      return forge.pki.certificateFromPem(certificate);
    } catch {
      return null;
    }
  }

  getAttribute(attrs: forge.pki.CertificateField[], name: string): string {
    return (attrs.find(attr => attr.name === name && typeof attr.value === 'string')?.value as string) || '';
  }

  getAllAttributes(attrs: forge.pki.CertificateField[], name: string): string[] {
    return attrs.filter(attr => attr.name === name && typeof attr.value === 'string').map(attr => attr.value as string);
  }

  getSubjectField(certificate: forge.pki.Certificate, fieldName: string): string {
    const value = certificate?.subject.getField(fieldName)?.value;
    return typeof value === 'string' ? value : '';
  }

  isIcpBrasilCertificate(certificate: string | forge.pki.Certificate | null | undefined): boolean {
    const parsedCertificate = typeof certificate === 'string' ? this.parsePem(certificate) : certificate;
    if (!parsedCertificate) {
      return false;
    }

    return this.getAttribute(parsedCertificate.issuer.attributes, 'organizationName').toLowerCase().includes('icp-brasil');
  }
}
